import React, { useState, useEffect } from 'react';
import { FormH1, TradeRow, TradesFormsContainer, SpinningIcon } from './TradeFormsElements';
import { candles } from '../LaytraderLibrary/LaytraderRequest';


function TradesList({ ticker, token, trades, selectedAccount }) {
    const [htmlData, setHTMLData] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (ticker != 'CASH') {
            const fetchData = async () => {
                const response = await candles(token, [ticker], selectedAccount);
                setHTMLData(response[ticker])
                setLoading(false);
            };
            fetchData();
        }
        else {
            setLoading(false);
        }
    }, [ticker]);


    const specificTrades = trades.length > 0 ? trades.filter(t => t.ticker == ticker) : [];

    return (
        <>
            {ticker === "CASH" ? <></> :
                <TradesFormsContainer>
                    {loading ? <SpinningIcon /> :
                        (
                            <>
                                {htmlData &&
                                    <iframe style={{ width: 'inherit', height: 'inherit' }} srcDoc={htmlData}></iframe>
                                } {/* {specificTrades.map(trade => (
                <TradeRow >
                    Ticker: {trade.ticker}, Shares: {trade.shares}, Cost: {trade.cost}
                </TradeRow>
            ))} */}
                            </>
                        )}
                </TradesFormsContainer>
            }
        </>
    );
}

export default TradesList;